import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { SongTableColumns, NotificationType } from 'constants/enums'
import { PLAY_SOURCES, PLAY_TRIGGERS } from 'constants/tracking'
import { browserHelpers } from 'utils'
import ModalActions from 'reducers/Modal'
import PlayQueueActions, { thunks as PlayQueueThunks } from 'reducers/PlayQueue'
import NotificationActions from 'reducers/Notification'
import { thunks as DownloadThunks } from 'reducers/Downloads'
import PlaylistActions, { thunks as PlaylistThunks } from 'reducers/PlayList'

import { DragDropSongsTable } from 'components'

import PlaylistTrackOptions from './PlaylistTrackOptions'

const mapStateToProps = ({ playList, player, playQueue }) => ({
  playlists: playList.playlistAbstracts,
  isPlaying: player.isPlaying,
  playQueue
})

@connect(mapStateToProps)
export default class PlaylistSongTable extends React.Component {
  static propTypes = {
    playlist: PropTypes.object,
    songs: PropTypes.arrayOf(PropTypes.object),
    playlists: PropTypes.arrayOf(PropTypes.object),
    playQueue: PropTypes.object,
    isPlaying: PropTypes.bool,
    dispatch: PropTypes.func.isRequired
  }

  state = {
    showModal: false,
    modalTrack: null
  }

  handleRemoveSong = (song) => {
    const { dispatch, playlist, playQueue, isPlaying } = this.props
    dispatch(PlaylistThunks.deleteSong(playlist, song))
    dispatch(
      PlayQueueThunks.deleteSong(song, playQueue, isPlaying, {
        source: PLAY_SOURCES.PLAYLIST_DETAIL,
        trigger: PLAY_TRIGGERS.REMOVE_CURRENT
      })
    )
    this.handleCloseModal(song)
  }

  handleDownloadSong = (song, format) => {
    const { dispatch } = this.props
    dispatch(
      DownloadThunks.addSongToDownloadQueue(song, {
        format,
        source: 'playlist_song_table'
      })
    )
    this.handleCloseModal(song)
  }

  handlePlayNext = (song) => {
    const { dispatch } = this.props
    dispatch(PlayQueueActions.insertItemNext(song))
  }

  handlePlayLater = (song) => {
    const { dispatch } = this.props
    dispatch(PlayQueueActions.insertItemAtBottom(song))
  }

  handleAddToPlaylist = (playlist, track) => {
    const { dispatch } = this.props

    dispatch(
      PlaylistThunks.addTracks(playlist.playlistid, [track.trackid], () =>
        dispatch(
          NotificationActions.broadcastMessage(
            {
              songTitle: track.artist + ' - ' + track.title,
              playlistTitle: playlist.name
            },
            NotificationType.addedToPlaylist
          )
        )
      )
    )
  }

  handleCreatePlaylist = (track) => {
    const { dispatch } = this.props

    dispatch(PlaylistActions.setSongsToAdd([track.trackid]))
    dispatch(ModalActions.togglePlaylistModal())
  }

  handleToggleModal = ({ trackid }) =>
    this.setState((state) => {
      const { showModal, modalTrack } = state

      const newState =
        trackid === modalTrack
          ? { showModal: !showModal }
          : { showModal: true, modalTrack: trackid }

      return newState
    })

  handleCloseModal = ({ trackid }) => {
    const { modalTrack } = this.state

    if (trackid === modalTrack) {
      this.setState({ showModal: false, modalTrack: null })
    }
  }

  renderModal = (track, hovered) => {
    const { showModal, modalTrack } = this.state
    const { playlist: currentPlaylist, playlists } = this.props

    const { candownload } = track

    const isDownloadAllowed =
      browserHelpers.browserAllowsDownload && candownload

    const showCurrentModal = showModal && modalTrack === track.trackid
    const hideTrigger = !(hovered || showCurrentModal)

    const playlistOptions = playlists.filter(
      (pl) => pl.playlistid !== currentPlaylist.playlistid
    )

    return (
      <PlaylistTrackOptions
        track={track}
        playlists={playlistOptions}
        isOpen={showCurrentModal}
        hideTrigger={hideTrigger}
        isDownloadAllowed={isDownloadAllowed}
        onRemoveClick={this.handleRemoveSong}
        onPlayNextClick={this.handlePlayNext}
        onPlayLaterClick={this.handlePlayLater}
        onDownloadClick={this.handleDownloadSong}
        onAddTrackToPlaylist={this.handleAddToPlaylist}
        onCreatePlaylist={this.handleCreatePlaylist}
        onToggle={() => this.handleToggleModal(track)}
      />
    )
  }

  render() {
    const { playlist, songs } = this.props

    return (
      <div className="scrollbar flex-1 mx-6">
        <DragDropSongsTable
          controlledHover
          playlist={playlist}
          items={songs}
          playSource={PLAY_SOURCES.PLAYLIST_DETAIL}
          columns={[
            SongTableColumns.index,
            SongTableColumns.coverart,
            SongTableColumns.artist,
            SongTableColumns.title,
            SongTableColumns.duration,
            SongTableColumns.labels,
            SongTableColumns.availableDate,
            SongTableColumns.impactDate
          ]}
          renderModal={this.renderModal}
          onHoverStop={this.handleCloseModal}
        />
      </div>
    )
  }
}
